import { appNavBar, initAppNavBar } from './app'
import {
  isMallApp,
  isMCMallKeyCustomerAndroid,
  isMCMallKeyCustomerIOS
} from '@mc/mc-base-env/src/web/platform'

export const navBar = {
  setTitle(config, handler) {
    if (
      isMallApp() ||
      isMCMallKeyCustomerAndroid() ||
      isMCMallKeyCustomerIOS()
    ) {
      initAppNavBar()
      typeof appNavBar.setTitle === 'function' &&
        appNavBar.setTitle(config, handler)
    } else {
      document.title = config.text
    }
  },
  setButton(position, btn) {
    initAppNavBar()
    typeof appNavBar.setButton === 'function' &&
      appNavBar.setButton(position, btn)
  }
}
